const hasUpperCase = value => (value && !/[A-Z]/.test(value) ? 'Password must contain uppercase character' : undefined);
const hasLowerCase = value => (value && !/[a-z]/.test(value) ? 'Password must contain lowercase characters' : undefined);
const hasNumbers = value => (value && !/\d/.test(value) ? 'Password must contain at least one digit' : undefined);

const PASSWORD_MIN_LENGTH = 7;
const PASSWORD_MAX_LENGTH = 15;

export { hasUpperCase, hasLowerCase, hasNumbers };

export const reduxFormValidators = {
  requiredValue: value => (value ? undefined : 'Required'),
  email: value => (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address' : undefined),
  minLength: value => (value && value.length < PASSWORD_MIN_LENGTH
    ? `Must be ${PASSWORD_MIN_LENGTH} characters or more` : undefined),
  maxLength: value => (value && value.length > PASSWORD_MAX_LENGTH
    ? `Must be ${PASSWORD_MAX_LENGTH} characters or less` : undefined),
};



// WEBPACK FOOTER //
// ./src/helpers/validators.js